import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { filterConstants } from "../../constants";

import {
  useApiPagedMetaSync,
  useGetPageQueryParams,
  useMerchantApiQueryWithParams,
  useQueryString,
} from "../../hooks";
import {
  IQueryStringNavLinks,
  ITableHeader,
  IViewVirtualAccountTransferRefund,
  IPageAndSearchRequest,
  PagedMeta,
} from "../../interfaces-and-types";
import { View } from "./View";

export interface IVirtualAccountTransferRefundQueryMeta {
  is_refund_completed?: boolean | null;

  start_date?: string | null;
  end_date?: string | null;
}

export interface IViewProps {
  data: IViewVirtualAccountTransferRefund[];
  headers: ITableHeader[];
  isLoading: boolean;
  isError: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // modals
  isCreateNewModalOpen: boolean;
  closeModal: () => void;

  // extra buttons
  onExport: () => void;

  openDetailsModal: (data: any) => void;
}

export const VIRTUAL_ACCOUNT_TRANSFER_LIST_TABLE_NAME = "issuesTable";

const IS_REFUND_COMPLETED_QUERY_KEY = "is_refund_completed"; // is_refund_completed

export const VirtualAccountTransferRefunds = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = useQueryString();
  const is_refund_completed =
    query.get(
      `${VIRTUAL_ACCOUNT_TRANSFER_LIST_TABLE_NAME}.${IS_REFUND_COMPLETED_QUERY_KEY}`
    ) ?? "false";
  const { page, page_size, search } = useGetPageQueryParams({
    queryStringPrefix: VIRTUAL_ACCOUNT_TRANSFER_LIST_TABLE_NAME,
  });

  const startDate = query.get(filterConstants.startDateKey);
  const endDate = query.get(filterConstants.endDateKey);

  const {
    isLoading: isLoadingVirtualAccountTransferRefundsList,
    isError: isErrorVirtualAccountTransferRefundsList,
    isSuccess: isSuccessVirtualAccountTransferRefundsList,
    data: virtualAccountTransferRefundsList,
    meta: pageMeta,
  } = useMerchantApiQueryWithParams<
    IPageAndSearchRequest & IVirtualAccountTransferRefundQueryMeta,
    IViewVirtualAccountTransferRefund[],
    PagedMeta
  >([
    "getVirtualAccountTransferRefundsList",
    {
      page: (page && Number(page)) || 1,
      page_size: (page_size && Number(page_size)) || 10,
      search,
      is_refund_completed: is_refund_completed === "true" ? true : false,
      start_date: startDate,
      end_date: endDate,
    },
  ]);

  console.warn(
    "VirtualAccountTransferRefunds:is_refund_completed ",
    is_refund_completed
  );

  useApiPagedMetaSync(pageMeta?.page_meta);

  const [isCreateNewModalOpen, setCreateNewModalOpen] = useState(false);
  const closeModal = () => {
    setCreateNewModalOpen(false);
  };

  const headers: ITableHeader[] = [
    {
      key: "refund_amount",
      header: "Refund Amount",
    },
    {
      key: "amount",
      header: "Invoice Amount",
    },
    {
      key: "amount_transferred",
      header: "Amount Sent",
    },
    {
      key: "status",
      header: "Status",
    },
    {
      key: "tx_ref",
      header: "Tx Ref",
    },
    {
      key: "customer_email",
      header: "Email",
    },
    {
      key: "customer_name",
      header: "Customer Name",
    },
    {
      key: "gateway",
      header: "Provider",
    },
    {
      key: "refund_reason",
      header: "Refund Reason",
    },
    {
      key: "date",
      header: "Date",
    },
    // {
    //   key: "more",
    //   header: "",
    // },
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: IS_REFUND_COMPLETED_QUERY_KEY,
    options: [
      {
        key: "Pending",
        value: "false",
      },
      {
        key: "Settled",
        value: "true",
      },
      // {
      //   key: "All",
      //   value: null,
      // },
    ],
  };

  const onExport = () => {
    alert("exporting data...");
  };

  const openDetailsModal = (id: any) => {
    navigate({
      pathname: `${id}/details`,
      search: location.search,
    });
  };

  return (
    <View
      data={virtualAccountTransferRefundsList || []}
      headers={headers}
      isLoading={isLoadingVirtualAccountTransferRefundsList}
      isError={isErrorVirtualAccountTransferRefundsList}
      totalCount={pageMeta?.page_meta.item_count || 0}
      queryStringTabs={queryStringTabs}
      isCreateNewModalOpen={isCreateNewModalOpen}
      onExport={onExport}
      closeModal={closeModal}
      openDetailsModal={openDetailsModal}
    />
  );
};
